import React from 'react';
import { AnalyticsEventLocation } from 'services/analytics/entities';
import { Song } from 'services/store/songs/types';
import {
  DesktopSongActionButtonsContainer,
  MobileSongActionButtonsContainer,
} from 'components/SongActionButtons/styled';
import DesktopSongActionButtons from 'components/SongActionButtons/DesktopSongActionButtons';
import MobileSongActionButtons from 'components/SongActionButtons/MobileSongActionButtons';

type PropsType = {
  song: Song;
  location: AnalyticsEventLocation;
};

const SongActionButtons: React.FC<PropsType> = ({ song, location }) => (
  <>
    <DesktopSongActionButtonsContainer>
      <DesktopSongActionButtons song={song} location={location} />
    </DesktopSongActionButtonsContainer>

    <MobileSongActionButtonsContainer>
      <MobileSongActionButtons song={song} location={location} />
    </MobileSongActionButtonsContainer>
  </>
);

export default SongActionButtons;
